'use client'

import { useFormContext } from 'react-hook-form'
import { Cell, InputTextArea } from '@vinted/web-ui'

const MAX_LENGTH = 10000

type Props = {
  name: string
  title: string
  placeholder: string
}

const PoliciesTextarea = ({ name, title, placeholder }: Props) => {
  const { register, watch } = useFormContext()

  const value: string = watch(name)

  const renderMaxLength = () => `${value.length}/${MAX_LENGTH}`

  return (
    <Cell styling={Cell.Styling.Tight}>
      <Cell title={title} />
      <InputTextArea
        {...register(name)}
        placeholder={placeholder}
        maxLength={MAX_LENGTH}
        validation={renderMaxLength()}
        uncontrolled
      />
    </Cell>
  )
}

export default PoliciesTextarea
